import _axios from '@/utils/request'

// 栏目列表
export function postProgramList (params) {
    return _axios('post', `/ms-shulan-hospital/v1/program/programList`, params)
}

// 添加progran
export function postAddProgram (params) {
    return _axios('post', `/ms-shulan-hospital/v1/program`, params)
}

// 获取program
export function getProgram (programId) {
    return _axios('get', `/ms-shulan-hospital/v1/program/${programId}`)
}

// 删除栏目
export function deleteProgram (programId) {
    return _axios('delete', `/ms-shulan-hospital/v1/program/${programId}`)
}

// 上架program
export function postShelfProgram (programId) {
    return _axios('post', `/ms-shulan-hospital/v1/program/shelfProgram/${programId}`)
}

// 下架program
export function postDismountedProgram (programId) {
    return _axios('post', `/ms-shulan-hospital/v1/program/dismountedProgram/${programId}`)
}

// 上移program
export function getMoveUp (programId) {
    return _axios('get', `/ms-shulan-hospital/v1/program/moveUp/${programId}`)
}

// 下移program
export function getMoveDown (programId) {
    return _axios('get', `/ms-shulan-hospital/v1/program/moveDown/${programId}`)
}

// 更新program
export function putProgram (params) {
    return _axios('put', `/ms-shulan-hospital/v1/program`, params)
}

// 获取科室列表
export function postListDepartment (params) {
    return _axios('post', `/ms-shulan-hospital/v1/department/listDepartment`, params)
}
